import script from "./CommonHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonHeader.vue?vue&type=script&setup=true&lang=js"

import "./CommonHeader.vue?vue&type=style&index=0&id=c5b976fa&scoped=true&lang=css"

import exportComponent from "E:\\Project\\New\\paypal-iframe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5b976fa"]])

export default __exports__